<template>
    <div class="login-container">
        <el-card class="login-card">
            <h2 class="title">{{ $t('welcome') }}</h2>
            <el-form :model="state.form" :rules="rules" ref="loginForm" label-width="100px" class="login-form">
                <el-form-item label="用户名" prop="username">
                    <el-input v-model="state.form.username" placeholder="请输入用户名" />
                </el-form-item>

                <el-form-item label="密码" prop="password">
                    <el-input v-model="state.form.password" type="password" placeholder="请输入密码"
                        @keyup.enter="handleLogin" />
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" class="login-btn" @click="handleLogin"
                        v-loading="state.loading">登录</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from 'vue-router';
import { useAdminStore } from "@/stores/admin";

const router = useRouter();
const adminStore = useAdminStore();

const loginForm = ref(null);

const state = reactive({
    loading: false,
    form: {
        username: "",
        password: "",
    },
});

const rules = {
    username: [
        { required: true, message: "Account can not be empty", trigger: "blur" },
    ],
    password: [
        { required: true, message: "Password can not be empty", trigger: "blur" },
    ],
};

function handleLogin() {
    if (state.loading) {
        return;
    }

    loginForm.value.validate(async valid => {
        if (valid) {
            state.loading = true;
            const success = await adminStore.login(state.form.username, state.form.password);
            state.loading = false;
            if (success) {
                router.push('/');
            }
        } else {
            ElMessage.error('请填写所有必填项');
        }
    });
}
</script>

<style scoped>
.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 80px);
    background-color: #f4f7fc;
}

.login-card {
    width: 400px;
    padding: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background-color: white;
}

.title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
}

.login-form {
    display: flex;
    flex-direction: column;
}

.login-btn {
    width: 100%;
    padding: 10px;
}
</style>
